import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import PmaBanksDrawer from "containers/pmaBanks";
import PaymentButton from "./components/button";
import PaymentContent from "./components/content";

const Payment = ({ amount, data, loading, onSetBanksData, onPaymentReq }) => {
  const navigate = useNavigate();
  const userPma = useSelector((state) => state?.pmaReducer?.userPma);

  const [paymentMethod, setPaymentMethod] = useState(
    data?.payment_methods?.[0]?.landing_url
  );
  const [openBank, setOpenBank] = useState(false);

  useEffect(() => {
    !userPma && navigate(-1);
  }, [userPma]);

  const onChangeMethods = (e) => {
    setPaymentMethod(e.target.value);
  };

  const handleBankInfo = (type) => {
    setOpenBank(type);
  };

  return (
    <>
      <div className="p-5 pt-8 ">
        <div className="py-10 px-4 bg-white shadow-xl rounded-lg">
          <PaymentContent
            data={{ ...data, amount }}
            paymentMethod={paymentMethod}
            handleBankInfo={handleBankInfo}
            onChangeMethods={onChangeMethods}
          />
          <PmaBanksDrawer
            open={openBank}
            onClose={() => handleBankInfo(false)}
            onSetBanksData={onSetBanksData}
          />
        </div>
      </div>
      <PaymentButton
        loading={loading}
        paymentMethod={paymentMethod}
        onPaymentReq={onPaymentReq}
      />
    </>
  );
};
export default Payment;
